import React from 'react';
import { ATSReport } from '@/api/types';

interface CoverageTabProps {
  report: ATSReport;
}

export function AnalysisCoverageTab({ report }: CoverageTabProps) {
  return (
    <div className="space-y-4">
      {report.requirementCoverage.length === 0 ? (
        <p className="text-sm text-slate-600 dark:text-slate-400">No coverage data available.</p>
      ) : (
        [...report.requirementCoverage].sort((a, b) => {
          const order = { 'strong': 1, 'partial': 2, 'missing': 3 };
          return (order[a.status as keyof typeof order] || 4) - (order[b.status as keyof typeof order] || 4);
        }).map((cov, i) => (
          <div key={i} className="p-4 border border-slate-300 dark:border-slate-800 rounded-lg bg-white dark:bg-slate-950 flex items-start flex-col sm:flex-row gap-4">
            <span className={`px-2 py-1 text-[10px] font-bold uppercase tracking-wider rounded border ${
              cov.status === 'strong' ? 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/20' :
              cov.status === 'partial' ? 'bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-500 border-amber-200 dark:border-amber-500/20' :
              'bg-rose-50 dark:bg-rose-500/10 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-500/20'
            }`}>
              {cov.status}
            </span>
            <div className="flex-1">
              <div className="text-sm font-bold text-slate-900 dark:text-slate-200 mb-2">{cov.req}</div>
              {cov.evidence && (
                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                  {cov.evidence}
                </p>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
